var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "单据编号",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: "请输入单据编号" },
                                    model: {
                                      value: _vm.queryParam.billNo,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "billNo", $$v)
                                      },
                                      expression: "queryParam.billNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "单据日期",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-range-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      format: "YYYY-MM-DD",
                                      placeholder: ["开始时间", "结束时间"],
                                    },
                                    on: {
                                      change: _vm.onDateChange,
                                      ok: _vm.onDateOk,
                                    },
                                    model: {
                                      value: _vm.queryParam.createTimeRange,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "createTimeRange",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.createTimeRange",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "往来单位",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择往来单位",
                                        showSearch: "",
                                        "allow-clear": "",
                                        optionFilterProp: "children",
                                      },
                                      on: { search: _vm.handleSearchOrgan },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "dropdownRender",
                                          fn: function (menu) {
                                            return _c(
                                              "div",
                                              {},
                                              [
                                                _c("v-nodes", {
                                                  attrs: { vnodes: menu },
                                                }),
                                                _c("a-divider", {
                                                  staticStyle: {
                                                    margin: "4px 0",
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "dropdown-btn",
                                                    on: {
                                                      mousedown: (e) =>
                                                        e.preventDefault(),
                                                      click: function ($event) {
                                                        return _vm.initOrgan(0)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("a-icon", {
                                                      attrs: { type: "reload" },
                                                    }),
                                                    _vm._v(" 刷新列表"),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          },
                                        },
                                      ]),
                                      model: {
                                        value: _vm.queryParam.organId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryParam,
                                            "organId",
                                            $$v
                                          )
                                        },
                                        expression: "queryParam.organId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.organList,
                                      function (item, index) {
                                        return _c(
                                          "a-select-option",
                                          {
                                            key: index,
                                            attrs: { value: item.id },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(item.supplier) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.handleToggleSearch },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.toggleSearchStatus
                                              ? "收起"
                                              : "展开"
                                          ) +
                                          "\n                  "
                                      ),
                                      _c("a-icon", {
                                        attrs: {
                                          type: _vm.toggleSearchStatus
                                            ? "up"
                                            : "down",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.toggleSearchStatus
                        ? [
                            _c(
                              "a-row",
                              { attrs: { gutter: 24 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "操作员",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择操作员",
                                              showSearch: "",
                                              "allow-clear": "",
                                              optionFilterProp: "children",
                                            },
                                            model: {
                                              value: _vm.queryParam.creator,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "creator",
                                                  $$v
                                                )
                                              },
                                              expression: "queryParam.creator",
                                            },
                                          },
                                          _vm._l(
                                            _vm.userList,
                                            function (item, index) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: index,
                                                  attrs: { value: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.userName) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "财务人员",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择财务人员",
                                              showSearch: "",
                                              "allow-clear": "",
                                              optionFilterProp: "children",
                                            },
                                            model: {
                                              value:
                                                _vm.queryParam.handsPersonId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "handsPersonId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryParam.handsPersonId",
                                            },
                                          },
                                          _vm._l(
                                            _vm.personList,
                                            function (item, index) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: index,
                                                  attrs: { value: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.name) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "收入账户",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择收入账户",
                                              showSearch: "",
                                              "allow-clear": "",
                                              optionFilterProp: "children",
                                            },
                                            model: {
                                              value: _vm.queryParam.accountId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "accountId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryParam.accountId",
                                            },
                                          },
                                          _vm._l(
                                            _vm.accountList,
                                            function (item, index) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: index,
                                                  attrs: { value: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.name) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "单据状态",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择单据状态",
                                              "allow-clear": "",
                                            },
                                            model: {
                                              value: _vm.queryParam.status,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "queryParam.status",
                                            },
                                          },
                                          [
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "0" } },
                                              [_vm._v("未审核")]
                                            ),
                                            !_vm.checkFlag
                                              ? _c(
                                                  "a-select-option",
                                                  { attrs: { value: "9" } },
                                                  [_vm._v("审核中")]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "1" } },
                                              [_vm._v("已审核")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "收入项目",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择收入项目",
                                              showSearch: "",
                                              "allow-clear": "",
                                              optionFilterProp: "children",
                                            },
                                            model: {
                                              value: _vm.queryParam.inOutItemId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "inOutItemId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryParam.inOutItemId",
                                            },
                                          },
                                          _vm._l(
                                            _vm.inOutItemList,
                                            function (item, index) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: index,
                                                  attrs: { value: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.name) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "单据备注",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "请输入单据备注",
                                          },
                                          model: {
                                            value: _vm.queryParam.remark,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "remark",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.remark",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "table-operator",
                  staticStyle: { "margin-top": "5px" },
                },
                [
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.myHandleAdd },
                        },
                        [_vm._v("新增")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "delete" },
                          on: { click: _vm.batchDel },
                        },
                        [_vm._v("删除")]
                      )
                    : _vm._e(),
                  _vm.checkFlag && _vm.btnEnableList.indexOf(2) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "check" },
                          on: {
                            click: function ($event) {
                              return _vm.batchSetStatus(1)
                            },
                          },
                        },
                        [_vm._v("审核")]
                      )
                    : _vm._e(),
                  _vm.checkFlag && _vm.btnEnableList.indexOf(7) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "stop" },
                          on: {
                            click: function ($event) {
                              return _vm.batchSetStatus(0)
                            },
                          },
                        },
                        [_vm._v("反审核")]
                      )
                    : _vm._e(),
                  _vm.isShowExcel && _vm.btnEnableList.indexOf(3) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "download" },
                          on: { click: _vm.handleExport },
                        },
                        [_vm._v("导出")]
                      )
                    : _vm._e(),
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        slot: "action",
                        placement: "left",
                        title:
                          "收入单主要处理一些销售收入以外的收入如维修服务收入、利息收入、调账收入等。",
                      },
                      slot: "action",
                    },
                    [
                      _vm.btnEnableList.indexOf(1) > -1
                        ? _c("a-icon", {
                            staticStyle: {
                              "font-size": "20px",
                              float: "right",
                            },
                            attrs: { type: "question-circle" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("a-table", {
                    ref: "table",
                    attrs: {
                      size: "middle",
                      bordered: "",
                      rowKey: "id",
                      columns: _vm.columns,
                      dataSource: _vm.dataSource,
                      components: _vm.handleDrag(_vm.columns),
                      pagination: _vm.ipagination,
                      scroll: _vm.scroll,
                      loading: _vm.loading,
                      rowSelection: {
                        selectedRowKeys: _vm.selectedRowKeys,
                        onChange: _vm.onSelectChange,
                      },
                    },
                    on: { change: _vm.handleTableChange },
                    scopedSlots: _vm._u([
                      {
                        key: "action",
                        fn: function (text, record) {
                          return _c(
                            "span",
                            {},
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.myHandleDetail(
                                        record,
                                        "收入",
                                        _vm.prefixNo
                                      )
                                    },
                                  },
                                },
                                [_vm._v("查看")]
                              ),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  })
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.myHandleEdit(record)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  )
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  })
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c(
                                    "a-popconfirm",
                                    {
                                      attrs: { title: "确定删除吗?" },
                                      on: {
                                        confirm: () =>
                                          _vm.myHandleDelete(record),
                                      },
                                    },
                                    [_c("a", [_vm._v("删除")])]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        },
                      },
                      {
                        key: "customRenderStatus",
                        fn: function (status) {
                          return [
                            status == "0"
                              ? _c("a-tag", { attrs: { color: "red" } }, [
                                  _vm._v("未审核"),
                                ])
                              : _vm._e(),
                            status == "1"
                              ? _c("a-tag", { attrs: { color: "green" } }, [
                                  _vm._v("已审核"),
                                ])
                              : _vm._e(),
                            status == "9"
                              ? _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("审核中"),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("item-in-modal", {
                ref: "modalForm",
                on: { ok: _vm.modalFormOk, close: _vm.modalFormClose },
              }),
              _c("financial-detail", {
                ref: "modalDetail",
                on: { ok: _vm.modalFormOk, close: _vm.modalFormClose },
              }),
              _c("bill-excel-iframe", {
                ref: "billExcelIframe",
                on: { ok: _vm.modalFormOk, close: _vm.modalFormClose },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }